import { ENDPOINT_MAP } from '../config/constants'

/**
 *
 * @param { string } domain The hosting platform's domain, used as a map's key
 * @returns The websocket URL for that domain
 * @default domain will default to our current demo WebSocket URL
 */
export const getWebSocketURL = (domain: string) => {
  return (
    ENDPOINT_MAP[domain]?.websocketProxyEndpoint ||
    'wss://api.ws.beta.assistant.skillbuilder.training.aws.dev/' // Using Beta's WS URL for now
  )
}

/**
 *
 * @param { string } domain The hosting platform's domain, used as a map's key
 * @returns The rest URL for that domain
 * @default domain will default to our current beta rest API URL
 */
export const getRestURL = (domain: string) => {
  return (
    ENDPOINT_MAP[domain]?.restProxyEndpoint ||
    'https://proxy.beta.assistant.skillbuilder.training.aws.dev/assistant/' // Using Beta's WS URL for now
  )
}
